/**
 *
 * @param {string} schoolTerm shortName ex. 2563/2
 * @returns {string} เทอม2_ปีการศึกษา2563
 */
const formatSchoolTerm = shortSchoolTerm => {
  if (!shortSchoolTerm.includes('/')) return shortSchoolTerm;

  const [year, term] = shortSchoolTerm.split('/');
  return `เทอม${term}_ปีการศึกษา${year}`;
};

/**
 *
 * @param {string} schoolTerm fullName ex. เทอม 2 ปีการศึกษา 2563
 * @returns {string} เทอม2_ปีการศึกษา2563
 */
const formatFullSchoolTerm = fullSchoolTerm => {
  const spaceRemovedSchoolTerm = fullSchoolTerm.replace(/\s/g, '');
  const position = spaceRemovedSchoolTerm.indexOf('ปีการศึกษา');

  if (!position > 0) return spaceRemovedSchoolTerm;
  return `${spaceRemovedSchoolTerm.substring(0, position)}_${spaceRemovedSchoolTerm.substring(
    position,
  )}`;
};

/**
 * Reorder each class's courses to match the report's top-level `courses` list,
 * matching by course code instead of array position. A course the class has
 * no data for becomes `null`.
 *
 * @param {Array<{ courses: Array<{ code: string }> }>} classes
 * @param {Array<{ courseCode: string }>} courses
 * @returns classes with `courses[i]` belonging to `courses[i].courseCode`
 */
const alignClassCoursesByCode = (classes = [], courses = []) =>
  classes.map(klass => {
    const courseByCode = new Map((klass.courses || []).map(course => [course.code, course]));
    return {
      ...klass,
      courses: courses.map(({ courseCode }) => courseByCode.get(courseCode) ?? null),
    };
  });

/**
 * Reorder each class's courseSections to match the report's top-level
 * `courseSections` list, matching by section id instead of array position.
 * A section the class has no data for becomes `null`.
 *
 * @param {Array<{ courseSections: Array<{ courseSectionId: string }> }>} classes
 * @param {Array<{ courseSectionId: string }>} courseSections
 */
const alignClassCourseSectionsById = (classes = [], courseSections = []) =>
  classes.map(klass => {
    const sectionById = new Map(
      (klass.courseSections || []).map(section => [section.courseSectionId, section]),
    );
    return {
      ...klass,
      courseSections: courseSections.map(
        ({ courseSectionId }) => sectionById.get(courseSectionId) ?? null,
      ),
    };
  });

export {
  formatSchoolTerm,
  formatFullSchoolTerm,
  alignClassCoursesByCode,
  alignClassCourseSectionsById,
};
